export default __webpack_public_path__ + "static/media/Mahabalipuram_Pancha ratha.b5ab0064.JPG";